import React from 'react';
import {Edit, SimpleForm} from 'react-admin';

import {CustomToolbar, Grid} from '../../components'
import SmsMessageLogFields from './SmsMessageLogFields'

export const SmsMessageLogEdit = props => (
    <Edit {...props}>
        <SimpleForm toolbar={<CustomToolbar viewOnly={true}/>}>
            <Grid container spacing={8}>
                <SmsMessageLogFields/>
            </Grid>
        </SimpleForm>
    </Edit>
);

export default SmsMessageLogEdit
